import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/logo.svg'
import _imports_1 from '../assets/img/title-ico2.png'
import _imports_2 from '../assets/img/title-ico.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-8e7ff962"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logobox" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_4 = {
  key: 0,
  src: _imports_1,
  alt: "",
  style: {"width":"7px","margin-right":"4px"}
}
const _hoisted_5 = {
  key: 1,
  src: _imports_2,
  alt: "",
  style: {"width":"7px","margin-right":"4px"}
}

import { reactive, toRefs, ref, onMounted, watchEffect, computed, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'header',
  setup(__props) {

const route = useRoute()
const router = useRouter();
let tabsList = reactive([
    [
        { name: '技术标准简介', path: '/introduction', isHovered: false, isActive: true, },
        { name: '联系我们', path: '/contactUs', isHovered: false, isActive: false, },
    ],
    [
        { name: '省公共服务平台', path: '/provincialServicePlatform', isHovered: false, isActive: false, },
        { name: '公共资源交易中心', path: '/tradingCenter', isHovered: false, isActive: false, },
        { name: '视频会议系统', path: '/venueVideoConferencingSystem', isHovered: false, isActive: false, },
        { name: '电子评标工具', path: '/bidEvaluationTools', isHovered: false, isActive: false, },
    ],
    [
        { name: '电子交易系统', path: '/tradingSystem', isHovered: false, isActive: false, },
        { name: '远程异地项目登记工具', path: '/remoteRegistrationTool', isHovered: false, isActive: false, },
        { name: '场所工位预约工具', path: '/placeReservationTool', isHovered: false, isActive: false, },
        { name: '专家库共享抽取工具', path: '/expertExtractionTool', isHovered: false, isActive: false, },
    ],
    [
        { name: '场地管理系统', path: '/venueManagementSystem', isHovered: false, isActive: false, },
        { name: '门禁系统', path: '/accessControlSystem', isHovered: false, isActive: false, },
        { name: '场地音视频监控工具', path: '/venueAudioAndVideoMonitoringTools', isHovered: false, isActive: false, },
    ],
    [
        { name: '评标专家库管理系统', path: '/bidEvaluationExpertDatabase', isHovered: false, isActive: false, },
        { name: '专家抽取终端', path: '/expertExtractionTerminal', isHovered: false, isActive: false, },
        { name: '场地专家签到工作台', path: '/expertSign', isHovered: false, isActive: false, },
        { name: '场地专家评标登录工作台', path: '/expertLogin', isHovered: false, isActive: false, },
    ],
    [
        { name: '远程异地评标目录服务组件', path: '/bidEvaluationComponent', isHovered: false, isActive: false, },
        { name: '评标专家库共享目录服务组件', path: '/expertLibraryComponent', isHovered: false, isActive: false, },
        { name: '共享组件标准接口联调', path: '/interfaceDebug', isHovered: false, isActive: false, },
    ],
    // [
    //     { name: '标准接口开发指南', path: '/interfaceGuide', isHovered: false, isActive: false, },
    // ],

    [

        // { name: '常见问题', path: '/problem', isHovered: false, isActive: false, },

    ],








])

let navMaxWidth = ref(1200);
const screenWidth = ref(document.body.clientWidth);
window.onresize = () => {
    console.log(document.body.clientWidth);
    screenWidth.value = document.body.clientWidth;
    if(screenWidth.value <= 1440){
        navMaxWidth.value = 1000;
    }
    if(screenWidth.value > 1440 && screenWidth.value <= 1920){
        navMaxWidth.value = 1200;
    }
    if(screenWidth.value > 1920){
        navMaxWidth.value = 1400;
    }
    
}

const bgOpacity = ref(0.6);
const bgbd = ref('none');
// 滚动事件处理函数
const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    bgOpacity.value = scrollTop < 577 ? 0.6 : 1; // 如果距离小于577，则透明度为0.6，否则为1
    bgbd.value = scrollTop > 577 ? '1px solid #E5E5E5' : 'none';
};

const toggleActive = (item: any) => {
    // 重置所有 tab 的 isActive 为 false
    tabsList.forEach(group => {
        group.forEach(tab => {
            tab.isActive = false;
            if (tab.path == item.path) {
                tab.isActive = true;
            }
        });
    });
    router.push({
        path: item.path,
    });

}



const tozy = () => {
    window.location.href = 'http://www.cebpubservice.com/'
}

watchEffect(() => {
    //tabsList.map((item: any) => {
    //     item.isActive = false;
    //     if (route.path.includes(item.path)) {
    //         item.isActive = true;
    //     }
    // })

    // if (route.path.includes('news')) {
    //    tabsList[0].isActive = true
    // }


    tabsList.forEach(group => {
        group.forEach(tab => {
            tab.isActive = false;
            if (route.path.includes(tab.path)) {
                tab.isActive = true;
            }
        });
    });



});


onMounted(() => {
    //tabsList.map((item: any) => {
    //     item.isActive = false;
    //     if (route.path.includes(item.path)) {
    //         item.isActive = true;
    //     }
    // })

    // if (route.path.includes('news')) {
    //    tabsList[0].isActive = true
    // }



    tabsList.forEach(group => {
        group.forEach(tab => {
            tab.isActive = false;
            if (route.path.includes(tab.path)) {
                tab.isActive = true;
            }
        });
    });


    window.addEventListener('scroll', handleScroll);


    screenWidth.value = document.body.clientWidth;
    if(screenWidth.value <= 1440){
        navMaxWidth.value = 1000;
    }
    if(screenWidth.value > 1440 && screenWidth.value <= 1920){
        navMaxWidth.value = 1200;
    }
    if(screenWidth.value > 1920){
        navMaxWidth.value = 1400;
    }


})

onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "header",
      style: _normalizeStyle({
            backgroundColor: `rgba(255, 255, 255, ${bgOpacity.value})`,
            border: `${bgbd.value}`
        })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "",
          style: _normalizeStyle({ width: screenWidth.value >= 1660 ? '263px' : '200px' }),
          class: "logoimg2"
        }, null, 4)
      ]),
      _createElementVNode("div", {
        class: "navbox",
        style: _normalizeStyle({
            maxWidth: `${_unref(navMaxWidth)}px`,
          
        })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabsList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "nav-column"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (item2, index2) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index2,
                class: _normalizeClass(["nav", { active: item2.isActive }]),
                onClick: ($event: any) => (toggleActive(item2)),
                style: _normalizeStyle({ fontSize: screenWidth.value >= 1660 ? '15px' : '14px' })
              }, [
                _createElementVNode("div", _hoisted_3, [
                  (item2.isActive)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                    : (_openBlock(), _createElementBlock("img", _hoisted_5)),
                  _createTextVNode(" " + _toDisplayString(item2.name), 1)
                ])
              ], 14, _hoisted_2))
            }), 128))
          ]))
        }), 128))
      ], 4),
      _createElementVNode("div", { class: "nav-right" }, [
        _createElementVNode("span", {
          onClick: tozy,
          style: {"cursor":"pointer","margin-top":"24px"}
        }, "返回首页  ")
      ])
    ], 4)
  ]))
}
}

})